import { Typography } from "@mui/material";
import DialogAnimate from "src/components/animate/DialogAnimate";
import useLocales from "src/hooks/useLocales";

import Context from "./context";
import CrateSecretForm from "./CrateSecretForm";
import SecretResult from "./SecretResult";
import useCreateSecretsActionsStore from "./store";

type Props = {
	show: boolean;
	onClose: () => void;
};

export default function CrateSecretDialog({ show, ...props }: Props) {
	const [state, actions] = useCreateSecretsActionsStore();
	const { secret } = state;

	const { translate } = useLocales();

	const onClose = () => {
		actions.setSecret("");
		props.onClose();
	};

	return (
		<DialogAnimate
			maxWidth={secret === "" ? "xs" : "sm"}
			onClose={props.onClose}
			open={show}
			disableBackdropClick
		>
			<Typography variant='subtitle1' fontSize={21} sx={{ p: 3, pb: 0 }}>
				{translate("app_secrets.new_secret")}
			</Typography>
			<Context.Provider value={{ actions: { ...actions, onClose }, state }}>
				{secret === "" ? <CrateSecretForm /> : <SecretResult />}
			</Context.Provider>
		</DialogAnimate>
	);
}
